import script from "./PartnerUserOnboardingFormDocumentsPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./PartnerUserOnboardingFormDocumentsPage.vue?vue&type=script&lang=ts&setup=true"

import "./PartnerUserOnboardingFormDocumentsPage.vue?vue&type=style&index=0&id=bf89ee90&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf89ee90"]])

export default __exports__